export const color = {
    primaryDark: "#1F1F1F",
    primaryLight: "#FFF",
    highlightedColor: "#E4F222",
    footerBg: "#FCFBFA",
    footerAdress: "#1F1F1FB2",
    fold2Bg: "#6D6D5D",
    darkGreen: "#12251A",
}